<template>
  <div>
    <ConfettiRadioButton
      v-for="item in data"
      :key="item.value"
      :checked="currentValueProxy === item.value"
      :disabled="disabled || item.disabled"
      :inline="inline"
      :name="name"
      :text="item.text"
      :value="item.value"
      @change="onChange"
    />
  </div>
</template>

<script>
import ConfettiRadioButton from "./ConfettiRadioButton";

export default {
  name: "ConfettiRadioButtons",
  components: { ConfettiRadioButton },
  props: {
    currentValue: {
      type: String,
      default: null,
    },
    data: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    inline: {
      type: Boolean,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return { currentValueProxy: this.currentValue };
  },
  methods: {
    onChange(value) {
      this.currentValueProxy = value;

      this.$emit("change", value);
    },
  },
};
</script>
